import { initCookieService } from '@eureka/utils/init-cookie';
import { getBrowserFingerprint } from '@patsnap-utils/browser-fingerprint';
import { createSharedComposable } from '@vueuse/core';
import { readonly, ref } from 'vue';

/**
 * 获取浏览器指纹 composable（全局单例）
 */
export const useBrowserFingerprint = createSharedComposable(() => {
    const fingerprint = ref('');

    const getFingerprint = async(): Promise<string> => {
        if (fingerprint.value) {
            return fingerprint.value;
        }
        try {
            fingerprint.value = initCookieService.getVisitorId() || await getBrowserFingerprint();
            return fingerprint.value;
        } catch (error) {
            console.error('[useBrowserFingerprint] 获取浏览器指纹失败:', error);
            return '';
        }
    };

    return {
        fingerprint: readonly(fingerprint),
        getFingerprint,
    };
});
